export default "__VITE_ASSET__CrDsbV4y__"